import { IProductPrice } from '@/types';
import { hasCompareCompetitors } from './compare-competitors';

/**
 * Whether to show "Compare e Comprove" when there is at least one competitor
 * with a valid higher price than our platform sale price (channel 1).
 */
export const showCompareEcomprove = ({
  product_prices,
  current_product_price,
  current_product_sale_price,
}: {
  product_prices?: IProductPrice[];
  current_product_price?: number;
  current_product_sale_price?: number;
}) => {
  return hasCompareCompetitors(product_prices, {
    sale_price: current_product_sale_price,
    price: current_product_price,
  });
};
